export default __webpack_public_path__ + "static/media/Wolfsteel Sabatons.2dfff872.jpg";